import { FC } from 'react'
import styled, { css } from 'styled-components'
import { NavLink, useLocation } from 'react-router-dom'
import { theme } from '@truepill/react-capsule'

type TTabItemVariant = 'primary' | 'secondary'

interface ITabItem {
  title?: string
  path?: string
  active?: boolean
  end?: boolean
  variant?: TTabItemVariant
  onClick?: () => void
}

export const TabItem: FC<ITabItem> = props => {
  const { title, active, path, variant = 'primary', end = false, ...rest } = props
  const { search } = useLocation()

  if (path) {
    return (
      <TabItemStyled variant={variant} {...rest}>
        <NavLink to={`${path}${search}`} end={end}>
          {title || ''}
        </NavLink>
      </TabItemStyled>
    )
  }

  return (
    <TabItemStyled className={active ? 'active' : ''} variant={variant} {...rest}>
      {title}
    </TabItemStyled>
  )
}

const TabItemDefaultStyle = css`
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  font-weight: 700;
  font-size: 0.875rem;
  text-decoration: none;

  & > a {
    text-decoration: none;
    display: block;
    color: ${theme.colors['typography-dark'].value};
  }
`
const TabItemPrimary = css`
  color: ${theme.colors['typography-dark'].value};

  &.active {
    border-bottom: ${theme.space['4xs'].value} ${theme.colors['primary-700'].value};
    color: ${theme.colors['primary-700'].value};
  }

  &:hover {
    color: ${theme.colors['primary-700'].value};
  }
  & > a {
    padding: ${theme.space.xs.value};
    border-bottom: ${theme.space['4xs'].value} solid transparent;

    &.active {
      border-color: ${theme.colors['primary-700'].value};
      color: ${theme.colors['primary-700'].value};
    }
  }
`
const TabItemSecondary = css`
  border-radius: ${theme.radii.xl.value};
  padding: ${theme.space.xs.value} ${theme.space.md.value};

  &.active {
    background: ${theme.colors['primary-700'].value};
    color: ${theme.colors.white.value};

    &:hover {
      background: ${theme.colors['primary-700'].value};
    }
  }
  &:hover {
    background: ${theme.colors['primary-300'].value};
  }
`

const TabItemStyled = styled.div<{ variant?: TTabItemVariant }>`
  ${TabItemDefaultStyle};
  ${({ variant = 'primary' }) => (variant === 'primary' ? TabItemPrimary : TabItemSecondary)}
`
